import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ONBOARDING_DELETE_CHAT_MESSAGE = gql`
    mutation OnboardingDeleteChatMessage($request: DeleteMessageRequestDto!) {
        onboardingDeleteChatMessage(request: $request)
    }
`;

const useOnboardingDeleteChatMessage = () => {
    const [mutate, { loading, error }] = useMutation(ONBOARDING_DELETE_CHAT_MESSAGE);

    const deleteChatMessage = async (messageUuid) => {
        return mutate({
            variables: {
                request: {
                    messageUuid,
                },
            },
        });
    };

    return {
        deleteChatMessage,
        loading,
        error,
    };
};

export default useOnboardingDeleteChatMessage;
